/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  PurchaseHistoryDetail,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    PurchaseHistoryDetailFromJSON,
    PurchaseHistoryDetailToJSON,
} from '../models';

export interface GetCurrentUserPurchaseHistoryRequest {
    xApplicationScope: ApplicationScope;
    productCanonicalId?: string;
}

/**
 * 
 */
export class PurchaseHistoryControllerApi extends runtime.BaseAPI {

    /**
     * get purchase history for current user
     * get purchase history for current user
     */
    async getCurrentUserPurchaseHistoryRaw(requestParameters: GetCurrentUserPurchaseHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PurchaseHistoryDetail>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCurrentUserPurchaseHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.productCanonicalId !== undefined) {
            queryParameters['productCanonicalId'] = requestParameters.productCanonicalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/purchase-history/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PurchaseHistoryDetailFromJSON));
    }

    /**
     * get purchase history for current user
     * get purchase history for current user
     */
    async getCurrentUserPurchaseHistory(requestParameters: GetCurrentUserPurchaseHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PurchaseHistoryDetail>> {
        const response = await this.getCurrentUserPurchaseHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
